import { isTransportOrder, type Order, type OrderStatus } from '#domain/Order.ts';

const OrderStatusWeight: Record<NonNullable<OrderStatus>, number> = {
    open: 1,
    planned: 2,
    'in-transit': 3,
    loading: 4,
    unloading: 5,
    executing: 5,
    finished: 6,
};

export const mapOrderStatusToOrderStatusWeight = (status: OrderStatus | undefined): number => {
    return status ? OrderStatusWeight[status] : 7;
};

export type OrderWithSortableKey<T extends Order = Order> = T & {
    statusWeight: number;
    loadingAddressEndDate?: string;
    unloadingAddressEndDate?: string;
    truckName?: string;
};

export const addSortableOrderKey = <T extends Order>(items: T[]): OrderWithSortableKey<T>[] =>
    items.map(item => ({
        ...item,
        loadingAddressEndDate: isTransportOrder(item) ? item.loadingStop.endTarget : item.executionStop.endTarget,
        unloadingAddressEndDate: isTransportOrder(item) ? item.unloadingStop.endTarget : item.executionStop.endTarget,
        truckName: item.truck?.name,
        statusWeight: mapOrderStatusToOrderStatusWeight(item.status),
    }));
